import React, { useState } from 'react'
import { useMutation, useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { BASIC_SERICES_ACTIVATE, BASIC_SERICES_DEACTIVATE, GET_BASICSERVICES } from '../../services/common/endpoints';
import Loadingcomponent from '../loader/loadingcomponent';
import ToggleActivationModal from './toggle-activation-modal';
import { callQueryapi } from '../../services/http/callapi';
import MessageModal from '../common/bottom-modal-message';
import Lottie from "lottie-react";
import dropdown from "../../../src/drop_down.json";
import dropdownup from "../../../src/drop_up.json";
import { SELECTED_LANG } from '../../services/common/Constants';
import { getItemOfSessionStorage } from '../../services/common/utils';

function BasicServices() {
    const lang = getItemOfSessionStorage(SELECTED_LANG);
    const { t } = useTranslation();
    const [show, setShow] = React.useState();
    const [servicesList, setServicesList] = useState([]);
    const [showActivationModal, setShowActivationModal] = useState(false);
    const [selectedService, setSelectedService] = useState('');
    const [showActivationMessage, setShowActivationMessage] = useState(false);
    const [activationLoading, setActivationLoading] = useState(false);
    const selectedmsisdn = useSelector(
        (state) => state?.userdata?.value?.selectedmsisdn
      );
    let basicServices = [];

    const basicServicesQr = useQuery(
        [
            "basic-services",
            GET_BASICSERVICES.url,
            GET_BASICSERVICES.data,
            {},
        ],
        {
            retry: false,
            retryOnMount: false,
            cacheTime: 0,
            staleTime: 0,
            onSuccess: ({ data }) => {
                const servicesToList = data?.response?.services?.map((service) => {
                    return {
                        checked: service?.status === 'A'
                    }
                });
                setServicesList(servicesToList);
            }
        }
    );

    const serviceActivateDeactivate = useMutation(
        (reqObj) =>
            callQueryapi({
                queryKey: [
                    {},
                    servicesList[selectedService]['checked'] ? BASIC_SERICES_DEACTIVATE : BASIC_SERICES_ACTIVATE,
                    reqObj,
                ],
            }),
        {
            onSuccess: ({ data }) => {
                setShowActivationModal(false);
                setShowActivationMessage(true);

                const servicesListCopy = JSON.parse(JSON.stringify(servicesList));

                if (data.status === '0') {
                    servicesListCopy[selectedService]['checked'] = !servicesListCopy[selectedService]['checked']
                    setServicesList(servicesListCopy);
                }
            }
        }
    );

    const handleServiceActivateDeactivate = (e, index) => {
        setSelectedService(index);
        handleToggleModal();
    }




    const handleToggleModal = () => {
        if(activationLoading){
            return;
        }
        
        setShowActivationModal(!showActivationModal);
    }

    const handleConfirm = () => {
        setActivationLoading(true);
        serviceActivateDeactivate.mutate({
            type: "basic",
            id: basicServices[selectedService]['serviceid'],
        });
    }

    const handleOk = () => {
        setShowActivationMessage(false);
        setActivationLoading(false);
    }

    if (basicServicesQr.isLoading) {
        return <Loadingcomponent />
    }

    const basicServicesData = basicServicesQr?.data?.data?.response;
    basicServices = basicServicesQr?.data?.data?.response?.services;


    let popupMessage = '';
    let popupCancelBtn = '';
    let popupActivationBtn = '';

    if (basicServices?.length > 0 && selectedService !== '') {
        popupMessage = basicServices[selectedService]['popup'][servicesList[selectedService]['checked'] ? 'deactivate_message' : 'activate_message'];
        
        try{
            if(popupMessage && popupMessage.includes("!MSISDN!"))
                popupMessage = popupMessage.replace('!MSISDN!',selectedmsisdn);
        }catch(e){}
        
        popupCancelBtn = basicServices[selectedService]['popup']['cancel_button'];
        popupActivationBtn = basicServices[selectedService]['popup'][servicesList[selectedService]['checked'] ? 'deactivate_button' : 'activate_button'];
    }


    let activationStatus = serviceActivateDeactivate?.data?.data?.status;
    let activationMessage = serviceActivateDeactivate?.data?.data?.message;
    let activationMessageToShow = '';
    if (activationStatus === '0') {
        activationMessageToShow = serviceActivateDeactivate?.data?.data?.message
    } else {
        activationMessageToShow = activationMessage ? activationMessage : t('somethingwentwrong')
    }

    return (
        <>
            <div className='white_card cs_padding_v1 mt-30 sprint14_dashboard_usage m-0 sprint14-linedetails-comp position-relative'>
                <div class="flex_grp_between">
                    <div class="balance_section_info">
                        <div class="d-flex">
                            <label>{basicServicesData?.title}</label>
                        </div>
                        <h3 class="balance">{basicServicesData?.headertitle}</h3>
                        <p>{basicServicesData?.description}</p>
                    </div>
                </div>
                <div class={`usage_list line-detail-list ${show ? "expand" : ""}`}>
                <div>
                  {servicesList?.map((item, index) => (
                     <>
                      <hr />
                        <div class="gx-2 demo sprint14-2row">
                            <div class="profile_info_desc">
                                <div> <h5>{basicServices[index]?.name}</h5></div>
                                <div>
                                {/* switch-rotate-180 */}
                                    <div class={`event_img d-flex ${lang === 'ar' ? 'switch-rotate-180' : ''}`}>
                                        <div class="cs_toggle_btn">
                                            <input type="checkbox" name="toggle" id={`label_id${index}`} checked={item?.checked} onChange={(e) => {
                                                handleServiceActivateDeactivate(e, index);

                                            }} />
                                            <label htmlFor={`label_id${index}`}>&nbsp;</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <p>
                                    {basicServices[index]?.description}
                                </p>
                            </div>
                        </div>
                     </>
                ))}
                </div>
               </div>
                 <div className="flex_grp_center">
                    <button
                      onClick={() => setShow(!show)}
                      className={`usage_more_btn sprint14-dropdown-arrow rm-service ${show ? "open" : ""}`}
                    >
                   {
                      show ? <> 
                      <Lottie animationData={dropdownup} loop={true} 
                      
                         />
                     </>:<>
                     <Lottie animationData={dropdown} loop={true} 

                      />
                      </>

                   }
                    </button>
                  </div>

            </div>

            <ToggleActivationModal show={showActivationModal} toggleModal={handleToggleModal} message={popupMessage} cancelBtn={popupCancelBtn} activationBtn={popupActivationBtn} onConfirm={handleConfirm} loading={activationLoading} />

            <MessageModal type='2' show={showActivationMessage} message={activationMessageToShow} handleOk={handleOk} />
        </>
    )
}

export default BasicServices